import React from "react";
import { useLocation } from "react-router-dom";

// The dashboard body scrolls inside the Frame's ChildrenInnerWrap
// (id="app-scroll-container"), not the window. Without this, navigating to a new
// page keeps the previous page's scroll offset (e.g. clicking a property far down
// the list opens its detail already scrolled down). Reset that container to the top
// on every pathname change (not search/hash, so tab-query and anchor links don't jump).
export const ScrollToTop = () => {
  const { pathname } = useLocation();

  React.useEffect(() => {
    document.getElementById("app-scroll-container")?.scrollTo({ top: 0 });
  }, [pathname]);

  return null;
};
